import React from 'react';
import Title from '../../components/Title';
import Subtitle from '../../components/Subtitle';

const Benefit = () => (
  <section className="bg-white py-20" id="sou-lojista">
    <div className="max-w-[1300px] w-full px-5 lg:px-0 mx-auto">
      <div className="flex justify-center items-center flex-col mb-0">
        <div className="flex flex-col">
          <Title className="text-center md:text-center px-12 md:px-20">
            Você é lojista? Descubra o que o Multi faz por você.
          </Title>
          <Subtitle className="max-w-3xl mx-auto mt-4 text-center md:text-center px-12 md:px-20">
            Saiba mais sobre as possibilidades para você.
          </Subtitle>
        </div>
        <div className="py-5 px-2">
          <a
            href="https://paginas.meumulti.com.br/lojista/"
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-[#014B35] text-white rounded-full px-8 py-4 w-full flex justify-center font-semibold text-sm"
          >
            Sou lojista
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default Benefit;
